import ArrowRightIcon from "assets/icons/v2/ArrowRightIcon";
import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Factors.module.scss";
import Button from "components/v2/Button/Button";
import { useRenewalsQuery } from "redux/RTQ/IlenkradApi";
import LoadingLottie from "components/lottieLoading/LoadingLottie";
import Factor from "components/v2/Factor/Factor";
import { Renewal } from "types/v2/Renewal/Renewal";
import useTypedTranslation from "hooks/V2/common/useTypedTranslation";

const Factors: React.FC = () => {
  //hooks
  const navigate = useNavigate();
  const { translate } = useTypedTranslation();
  //APIs
  const { data, isLoading } = useRenewalsQuery();

  if (isLoading) {
    return <LoadingLottie />;
  }
  return (
    <>
      <div className={classes["factors-container"]}>
        <div className={classes.header}>
          <div className={classes.title}>
            <ArrowRightIcon onClick={() => navigate("/")} />
            <p className={classes["factors-title"]}>
              {translate("RenewalHistory")}
            </p>
          </div>
          <Button
            type="secondary"
            text="تمدید سامانه"
            onClick={() => navigate("/plans")}
            additionalStyles={classes.pay}
          />
        </div>
        {data?.renewals?.map((renewal: Renewal) => (
          <Factor renewal={renewal} key={renewal?.id} />
        ))}
      </div>
    </>
  );
};
export default Factors;
